/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Registry_PandiInputs */

const id_tld_pricing_registry_pandi = /** @type {(inputs: Tld_Pricing_Registry_PandiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pandi`)
};

const en_tld_pricing_registry_pandi = /** @type {(inputs: Tld_Pricing_Registry_PandiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pandi`)
};

/**
* | output |
* | --- |
* | "Pandi" |
*
* @param {Tld_Pricing_Registry_PandiInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_registry_pandi = /** @type {((inputs?: Tld_Pricing_Registry_PandiInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Registry_PandiInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_registry_pandi(inputs)
	return id_tld_pricing_registry_pandi(inputs)
});